import { useEffect } from "react";
import { useLocation } from "react-router-dom";
//import AOS from "aos";

export default function ScrollTop() {
    const { pathname } = useLocation();

    useEffect(() => {
        //window.scrollTo(0, 0);

        window.scrollTo({ top: 0, behavior: "instant" });

        // Give a slight delay before refreshing AOS
        //setTimeout(() => {
        //    AOS.refreshHard(); // Use refreshHard to reinitialize delays too
        //}, 100);

    }, [pathname]);

    return null;
}
